<div nz-flex nzAlign="center" nzJustify="center" class="logo-container">
  <img class="logo" src="/assets/mathema-logo-2.png" alt="Mathema.me" />
</div>
